export const EU_LANGUAGES = [
    {code: "bg", label: "Bulgarian", native: "български", country: "bg"},
    {code: "cs", label: "Czech", native:"česky", country: "cz"},
    {code: "da", label: "Danish", native:"dansk", country: "dk"},
    {code: "de", label: "German", native:"Deutsch", country: "de"},
    {code: "el", label: "Greek", native:"ελληνικά", country: "gr"},
    {code: "en", label: "English", native:"English", country: "en"},
    {code: "es", label: "Spanish", native:"español", country: "es"},
    {code: "et", label: "Estonian", native:"eesti", country: "ee"},
    {code: "fi", label: "Finnish", native: "suomi", country: "fi"},
    {code: "fr", label: "French", native:"français", country: "fr"},
    {code: "ga", label: "Irish", native: "Gaeilge", country: "ie"},
    {code: "hr", label: "Croatian", native:"hrvatski", country: "hr"},
    {code: "hu", label: "Hungarian", native:"magyar", country: "hu"},
    {code: "it", label: "Italian", native: "italiano", country: "it"},
    {code: "lt", label: "Lithuanian", native: "lietuvių", country: "lt"},
    {code: "lv", label: "Latvian", native: "latviešu", country: "lv"},
    {code: "mt", label: "Maltese", native: "Malti", country: "mt"},
    {code: "nl", label: "Dutch", native: "Nederlands", country: "nl"},
    {code: "pl", label: "Polish", native: "polski", country: "pl"},
    {code: "pt", label: "Portuguese", native: "português", country: "pt"},
    {code: "ro", label: "Romanian", native: "română", country: "ro"},
    {code: "sk", label: "Slovak", native: "slovenčina", country: "sk"},
    {code: "sl", label: "Slovenian", native: "slovenščina", country: "si"},
    {code: "sv", label: "Swedish", native: "svenska", country: "se"},
    // {code: "nb", label: "Norwegian Bokmål", country: "no"},
    // {code: "nn", label: "Norwegian Nynorsk", country: "no"},
  ];
